<template>
  <div class="colorbar" :style="styleObject">
    <div class="row-title"> 
      <div class="one" 
        v-for="color in colors" :key="color">
        <div class="text" v-if="color.text">{{ color.text }}</div>
        <div class="text_right" v-if="color.text_right">{{ color.text_right }}</div>
        <div class="text_left" v-if="color.text_left">{{ color.text_left }}</div>
      </div>
    </div>
    <div class="row-block" :style="{backgroundColor: colors[colors.length-1].value}"> 
      <div class="one" v-for="color in colors"
        :key="color" 
        :title="color.longText || color.text"
        :style="{backgroundColor: color.value}">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["colors", "display"],

  computed: {
    styleObject() {
      return this.display == "none" ? {"display": "none"} : {}
    }
  }
}
</script>

<style>

.colorbar { 
  width: auto; 
  margin: 5px 20px;
}

.colorbar .row-title{ 
  width: auto;
  display: flex; 
  flex-direction:row;
  height: 20px;
  border: 1px solid white;
}

.colorbar .row-title .one { 
  flex: 1; 
  text-align: center;
}

.colorbar .row-block {
  width: auto;
  display: flex; 
  flex-direction:row;
  border: 1px solid #444;
  border-right-width: 1px;
}

.colorbar .row-block .one { 
  flex: 1; 
  height: 10px;
}

.colorbar .one .text {
  width: 100%;
  height: 10px;
}

.colorbar .one .text_right {
  height: 10px;
  width: 100%;
  float:right;
  margin-right: -50%;
  font-size: 10px;
}

.colorbar .one .text_left {
  height: 10px;
  width:100%;
  float:left;
  margin-left: -50%;
  font-size: 10px;
}

.colorbar .one .block {
  width: 100%;
  height: 10px;
}
</style>